
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import moment from 'moment';
// import LeadChecklistTitleCircle from '@/components/LeadChecklistTitleCircle.vue';
import { Checklist, Lead } from '@/types';

moment.locale('it');

@Component
export default class LeadChecklistTitle extends Vue {
  @Prop(Object) readonly checklist!: Checklist;

  get lead(): Lead {
    return this.$store.getters.currentLead;
  }

  get title() {
    return this.checklist.name;
  }

  get subtitle() {
    return null;
  }
}
